import { h, FunctionComponent } from 'preact';
import { Trans, useTranslation } from 'react-i18next';
import CheckboxInput from '~src/domains/common/components/CheckboxInput';
import InfoTooltip from '~src/domains/common/components/InfoTooltip';
import * as styles from '~src/styles/domains/accept/components/AutoPayCheckbox.module.scss';
import { AutoPayCheckboxProps } from '../types/components';

const AutoPayCheckbox: FunctionComponent<AutoPayCheckboxProps> = ({
  id,
  checked,
  disabled = false,
  required = true,
  onChangePost,
  onBlurHandler,
  style = {},
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles['autopay-wrapper']}>
      <label
        className={
          checked
            ? `${styles['autopay-switch']} ${styles['autopay-checked']}`
            : styles['autopay-switch']
        }
      >
        <CheckboxInput
          id={id}
          label='autopay-checkbox'
          checked={checked}
          onChangeHandler={onChangePost}
          onBlurHandler={onBlurHandler}
          disabled={disabled}
          required={required}
          style={{ opacity: 0, width: 0, height: 0, ...style }}
        />
        <span class={styles['autopay-slider']}></span>
      </label>
      <label for='autopay'>{t('accept:autopay.label')}</label>
      <InfoTooltip id='autopay-tooltip'>
        <Trans t={t} i18nKey='accept:autopay.content' />
      </InfoTooltip>
    </div>
  );
};

export default AutoPayCheckbox;
